import React from "react";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import { required, email } from "redux-form-validators";
import { renderField, renderselect, renderTextField } from "../../../Components/Forms/renders";

class ProfielForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
    };
  }

  render() {
    const { handleSubmit, initialValues } = this.props;
    
    return (
      <form onSubmit={handleSubmit}>
        <div className="row">
          {/* Personal Information */}
          <div className="col-md-6">
            <div className="card mb-4">
              <div className="card-header d-flex align-items-center">
                <i className="bx bx-user me-2"></i>
                <h5 className="mb-0">Persoonlijke Informatie</h5>
              </div>
              <div className="card-body">
                <div className="mb-3">
                  <Field 
                    name="voornaam" 
                    validate={[required({ allowBlank: true })]} 
                    type="text" 
                    component={renderField} 
                    label="Voornaam" 
                  />
                </div>
                <div className="mb-3">
                  <Field 
                    name="achternaam" 
                    validate={[required({ allowBlank: true })]} 
                    type="text" 
                    component={renderField} 
                    label="Achternaam" 
                  />
                </div>
                <div className="mb-3">
                  <Field 
                    name="email" 
                    validate={[email({ allowBlank: true })]} 
                    type="email" 
                    component={renderField} 
                    label="E-mailadres" 
                  />
                </div>
                <div className="mb-3">
                  <Field 
                    name="telefoonnummer" 
                    type="tel" 
                    component={renderField} 
                    label="Telefoonnummer" 
                  />
                </div>
                <div className="mb-3">
                  <Field 
                    name="geboortedatum" 
                    type="date" 
                    component={renderField} 
                    label="Geboortedatum" 
                  />
                </div>
                <div className="mb-0">
                  <Field 
                    name="geslacht" 
                    component={renderselect} 
                    label="Geslacht"
                    options={{
                      '': 'Kies geslacht...',
                      'man': 'Man',
                      'vrouw': 'Vrouw',
                      'anders': 'Anders',
                      'zeg_ik_liever_niet': 'Zeg ik liever niet'
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Contact & Address Information */}
          <div className="col-md-6">
            <div className="card mb-4">
              <div className="card-header d-flex align-items-center">
                <i className="bx bx-map me-2"></i>
                <h5 className="mb-0">Adres & Contact</h5>
              </div>
              <div className="card-body">
                <div className="mb-3">
                  <Field 
                    name="straat" 
                    type="text" 
                    component={renderField} 
                    label="Straatnaam en huisnummer" 
                  />
                </div>
                <div className="row">
                  <div className="col-md-4 mb-3">
                    <Field 
                      name="postcode" 
                      type="text" 
                      component={renderField} 
                      label="Postcode" 
                    />
                  </div>
                  <div className="col-md-8 mb-3">
                    <Field 
                      name="woonplaats" 
                      type="text" 
                      component={renderField} 
                      label="Woonplaats" 
                    />
                  </div>
                </div>
                <div className="mb-3">
                  <Field 
                    name="land" 
                    component={renderselect} 
                    label="Land"
                    options={{
                      'Nederland': 'Nederland',
                      'België': 'België',
                      'Duitsland': 'Duitsland',
                      'Frankrijk': 'Frankrijk',
                      'Verenigd Koninkrijk': 'Verenigd Koninkrijk',
                      'Anders': 'Anders'
                    }}
                  />
                </div>
                <div className="mb-3">
                  <Field 
                    name="noodcontact_naam" 
                    type="text" 
                    component={renderField} 
                    label="Noodcontact - Naam" 
                  />
                </div>
                <div className="mb-0">
                  <Field 
                    name="noodcontact_telefoon" 
                    type="tel" 
                    component={renderField} 
                    label="Noodcontact - Telefoon" 
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Work Information */}
        <div className="row">
          <div className="col-12">
            <div className="card mb-4">
              <div className="card-header d-flex align-items-center">
                <i className="bx bx-briefcase me-2"></i>
                <h5 className="mb-0">Werk Informatie</h5>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-4 mb-3">
                    <Field 
                      name="functietitel" 
                      type="text" 
                      component={renderField} 
                      label="Functietitel" 
                    />
                  </div>
                  <div className="col-md-4 mb-3">
                    <Field 
                      name="afdeling" 
                      type="text" 
                      component={renderField} 
                      label="Afdeling" 
                    />
                  </div>
                  <div className="col-md-4 mb-3">
                    <Field 
                      name="startdatum" 
                      type="date" 
                      component={renderField} 
                      label="Startdatum" 
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <Field 
                      name="werktijden" 
                      component={renderselect} 
                      label="Werktijden"
                      options={{
                        'voltijd': 'Voltijd (40 uur)',
                        'deeltijd_32': 'Deeltijd (32 uur)',
                        'deeltijd_24': 'Deeltijd (24 uur)',
                        'deeltijd_16': 'Deeltijd (16 uur)',
                        'flex': 'Flexibele uren',
                        'oproep': 'Oproepkracht'
                      }}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <Field 
                      name="locatie" 
                      type="text" 
                      component={renderField} 
                      label="Werklocatie" 
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Additional Information */}
        <div className="row">
          <div className="col-12">
            <div className="card mb-4">
              <div className="card-header d-flex align-items-center">
                <i className="bx bx-info-circle me-2"></i>
                <h5 className="mb-0">Overige Informatie</h5>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <Field 
                      name="taal_voorkeur" 
                      component={renderselect} 
                      label="Taalvoorkeur"
                      options={{
                        'nl': 'Nederlands',
                        'en': 'Engels',
                        'de': 'Duits',
                        'fr': 'Frans'
                      }}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <Field 
                      name="tijdzone" 
                      component={renderselect} 
                      label="Tijdzone"
                      options={{
                        'Europe/Amsterdam': 'Europa/Amsterdam',
                        'Europe/Brussels': 'Europa/Brussel',
                        'Europe/Berlin': 'Europa/Berlijn'
                      }}
                    />
                  </div>
                </div>
                <div className="mb-3">
                  <Field 
                    name="bio" 
                    component={renderTextField} 
                    label="Bio / Over mijzelf"
                    rows={3}
                  />
                </div>
                <div className="mb-0">
                  <Field 
                    name="specialiteiten" 
                    component={renderTextField} 
                    label="Specialiteiten / Vaardigheden"
                    rows={2}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Submit Button */}
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <small className="text-muted">
                      <i className="bx bx-info-circle me-1"></i>
                      Je gegevens worden beveiligd opgeslagen en alleen gebruikt voor account beheer.
                    </small>
                  </div>
                  <div>
                    <button type="submit" className="btn btn-primary">
                      <i className="bx bx-save me-1"></i>
                      Profiel Bijwerken
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  }
}
ProfielForm = reduxForm({
  form: "formprofiel", // a unique identifier for this form
})(ProfielForm);

// You have to connect() to any reducers that you wish to connect to yourself
ProfielForm = connect(
  (state) => ({
    initialValues: state.auth.user, // pull initial values from account reducer
  }) // bind account loading action creator
)(ProfielForm);

export default ProfielForm;
